import { createFileRoute, redirect } from '@tanstack/react-router'
import { COMPLIANCE_REDIRECTS } from '@/lib/compliance-redirects'

export const Route = createFileRoute('/_authenticated/_organization/ndis-standards/policies')({
  beforeLoad: () => {
    // `to` is a dynamic lookup (plain `string`), so the router can't validate
    // an object against an unknown target's search schema — `true` preserves
    // whatever query params the caller arrived with across the redirect.
    throw redirect({ to: COMPLIANCE_REDIRECTS['/ndis-standards/policies'], search: true, replace: true })
  },
  component: () => null,
})
